import styled, { css as styledCss } from "styled-components";
import { sva } from "@stubhub/broadway-foundation/css";
import { Skeleton } from "@viagogo/core/ui";
import { LoadingBackgroundStyle } from "src/website-apps/shared/components/LoadingCarousel.styled";

/* ── sva recipe: all slots of the SignInBanner ────────────────── */

export const signInBannerRecipe = sva({
  slots: ["container", "body", "flexContent", "text", "heading", "cta", "divider", "buttonWrap", "icon", "close"],
  className: "signInBanner",
  base: {
    container: {
      paddingBlock: "primitives.200",
      paddingInline: "primitives.200",
      marginBlock: "[28px]",
      marginInline: "[-16px]",
      backgroundColor: "bg.surface.brand",
      display: "flex",
      justifyContent: "space-between",
    },
    body: {
      display: "flex",
      paddingBlock: "primitives.100",
      columnGap: "primitives.200",
      rowGap: "primitives.200",
      tablet: {
        justifyContent: "center",
        alignItems: "center",
        width: "full",
      },
    },
    flexContent: {
      display: "flex",
      alignItems: "flex-start",
      flexDirection: "column",
      tablet: {
        alignItems: "center",
        flexDirection: "row",
      },
    },
    text: {
      columnGap: "primitives.100",
      rowGap: "primitives.100",
      color: "text.brand",
    },
    heading: {
      textStyle: "header.medium",
      display: "inline-block",
    },
    cta: {
      display: "flex",
      alignItems: "flex-start",
      columnGap: "primitives.200",
      rowGap: "primitives.200",
      marginBlockStart: "primitives.250",
      tablet: {
        marginBlockStart: "primitives.0",
      },
    },
    divider: {
      display: "none",
      tablet: {
        display: "block",
        width: "primitives.0",
        borderInlineStartWidth: "[1.5px]",
        borderInlineStartStyle: "solid",
        borderInlineStartColor: "text.brand",
        alignSelf: "center",
        height: "primitives.700",
        marginInline: "primitives.700",
      },
    },
    buttonWrap: {
      "& > a": {
        textWrap: "nowrap",
      },
    },
    icon: {
      color: "text.brand",
      height: "primitives.400",
      width: "primitives.400",
    },
    close: {
      cursor: "pointer",
      color: "text.brand",
    },
  },
});

/* ── Styled-components (KEEP: Skeleton + LoadingBackgroundStyle) ── */

const SignInBannerBaseCss = styledCss`
  padding: ${({ theme }) => theme.spacing(4)};
  margin: ${({ theme }) => theme.spacing(7, -4)};
`;

const SignInBannerContainerStyled = styled.div`
  ${SignInBannerBaseCss}
  background-color: ${({ theme }) => theme.colors.primary700};
  display: flex;
  justify-content: space-between;
`;

const SIGNIN_SKELETON_HEIGHT = "104px";

export const SignInBannerLoadingSkeleton = styled(SignInBannerContainerStyled)`
  ${LoadingBackgroundStyle}
  height: ${SIGNIN_SKELETON_HEIGHT};
`;

/** exp 22299 -- introduce NPM Core Skeleton */
export const SignInBannerSkeleton = styled(Skeleton)`
  ${SignInBannerBaseCss}
  box-sizing: border-box;
  height: ${SIGNIN_SKELETON_HEIGHT};
`;
